export default __webpack_public_path__ + "static/media/pic9.d62fbf8a.jpg";